import { styled } from '@mui/material';
// TODO: to delete `reduceHeight` prop if it is not used.
export const IconContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'reduceHeight' })(({ theme, reduceHeight }) => ({
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    // Removes 2px height from top and 2px height from bottom.
    ...(reduceHeight && { marginTop: theme.spacing(-0.5), marginBottom: theme.spacing(-0.5) }),
}));
